import React from "react";
import { LoginComponent } from "../components/login/LoginComponent"

export const LoginPage = () => {
    return (
        <div>
            <LoginComponent />
        </div>
    );
}